module.exports = __webpack_public_path__ + "static/feature-payments-e5747254454b7186e3eda472ca37c57f.png";